module.exports = __webpack_public_path__ + "img/08.d11a6415.jpg";